<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.adInformation'|translate}}</h3>
    </div>

    <app-input-field [control]="formGroup.controls.proposalName" class="field-container"
                     [label]="'createProposal.proposalName'|translate">
      <input name="proposalName" formControlName="proposalName" class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.classificationTerm" class="field-container"
                     [label]="'createProposal.classificationTerm'|translate">
      <input name="classificationTerm" formControlName="classificationTerm" class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.deadline" class=" field-container"
                     [label]="'createProposal.deadline'|translate">
      <input name="deadline"
             formControlName="deadline" type="date"
             class="input">
    </app-input-field>

    <hr class="line">

    <div class="pb-3">
      <div class="d-flex flex-row">
        <app-info-icon class="info-i" [header]="'infoIcon.privateProposal.header'|translate"
                       [mainContent]="'infoIcon.privateProposal.content'|translate"
                       [isAbove]="true"
                       [marginValue]="9"></app-info-icon>
        <mat-slide-toggle ngDefaultControl formControlName="privateProposal" name="privateProposal" class="slider"
                          labelPosition="before">{{'createProposal.isPublicAd'|translate}}</mat-slide-toggle>
      </div>
    </div>

    <div *ngIf="this.formGroup.value.privateProposal">
      <h5>{{'createProposal.memberCircle'| translate}}</h5>

      <ng-container *ngFor="let usersAllowedToView of formGroup.controls.usersAllowedToView.controls; let i = index">
        <div class="d-flex flex-column mt-3" [formGroup]="usersAllowedToView">
          <div class="d-flex justify-content-between align-items-center addressee h-32">
            <div>{{('createProposal.addressee' | translate) + (i + 1)}}</div>
            <div class="d-flex align-items-center">
              <button *ngIf="formGroup.controls.usersAllowedToView.length > 1" (click)="deleteMember(i)"
                      class="delete-button d-flex align-items-center"><img
                src="assets/img/form/trashbin.svg"
                alt=""></button>
            </div>
          </div>

          <app-input-field [control]="usersAllowedToView.controls.id"
                           [showLabel]="false"
                           class="w-100 addressee-input">

            <mat-select formControlName="id"
                        [value]="usersAllowedToView.value.id"
                        class="input">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="proposalInformationSearchArray[i].filterCtrlUser"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let user of (proposalInformationSearchArray[i].filteredOptionsUser | async)"
                          [value]="user.id">
                <div class="d-flex justify-content-start align-items-center">
                  <img class="rounded-circle profile-picture"
                       [src]="(userService.getProfilePicture(user.id) |async) ??'assets/img/profile/default-profile-icon.png'"
                       alt="Avatar"/>
                  <div class="ms-2 profile-name">{{user.company.name}} - <span class="company">{{user.firstName}} {{user.lastName}}</span></div>
                </div>
              </mat-option>
            </mat-select>

          </app-input-field>
        </div>
      </ng-container>
      <div class="d-flex justify-content-start ">
        <button *ngIf="formGroup.controls.usersAllowedToView.length<maxNumber" id="addButton" class="add-button mt-3"
                (click)="addMember()">
          + {{'createProposal.addUser'|translate}}</button>
      </div>
    </div>

    <hr class="line">

    <app-input-field [control]="formGroup.controls.otherInformation" class="field-container"
                     [label]="'createProposal.otherInformation'|translate">
      <textarea formControlName="otherInformation"
                class="input input-text-area" cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                placeholder="{{'createProposal.otherInformationPlaceholder' | translate}}"> </textarea>
    </app-input-field>


  </div>
</form>
